// import axios from "axios";
// import { BASE_URL } from "../keys";
// import { notification } from "antd";
// import { getToken, isTokenExpired } from "../utilities/tokenUtils";

// const api = axios.create({
//   baseURL: BASE_URL,
//   headers: { "Content-Type": "application/json" },
// });

// let isRefreshing = false;
// let failedQueue = [];

// const processQueue = (error, token = null) => {
//   failedQueue.forEach((prom) =>
//     error ? prom.reject(error) : prom.resolve(token)
//   );
//   failedQueue = [];
// };

// function logoutUser() {
//   localStorage.clear();
//   notification.error({
//     message: "Session expired",
//     description: "Please login again",
//   });
//   setTimeout(() => { window.location.href = "/login"; }, 1500);
// }

// async function refreshAccessToken() {
//   console.log("vfg");
  
//   const refreshToken = localStorage.getItem("refresh_token");
//   if (!refreshToken) throw new Error("No refresh token");

//   const { data } = await axios.post(`${BASE_URL}api/token/refresh`, {
//     refresh: refreshToken,
//   });
//   console.log(data);

//   const newAccessToken = data.access;
//   localStorage.setItem("livtoken", newAccessToken);

//   // If the backend rotates the refresh token and returns a new one, save it
//   if (data.refresh) {
//     localStorage.setItem("refresh_token", data.refresh);
//   } else if (data.refresh_token) {
//     localStorage.setItem("refresh_token", data.refresh_token);
//   }

//   // api.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;
//   return newAccessToken;
// }

// // ── REQUEST interceptor: proactively refresh before sending ──────────────
// api.interceptors.request.use(async (config) => {
//   const isAuthUrl =
//     config.url?.includes("/login") ||
//     config.url?.includes("/token/") ||
//     config.url?.includes("/otp") ||
//     config.url?.includes("/register");

//   if (isAuthUrl) return config;
//  delete config.headers.Authorization;
//   delete config.headers.authorization;
//   const token = getToken();

//   // Token exists but is expired — refresh before the request goes out
//   if (token && isTokenExpired(token)) {
//     console.log("token");
    
//     if (isRefreshing) {
//       console.log(isRefreshing);
      
//       // Another request is already refreshing — wait for it
//       return new Promise((resolve, reject) => {
//         failedQueue.push({ resolve, reject });
//       }).then((newToken) => {
//         config..Authorization = `Bearer ${newToken}`;
//         return config;
//       });
//     }

//     isRefreshing = true;
//     try {
     
//       const newToken = await refreshAccessToken();
//        console.log(newToken);
      
//       processQueue(null, newToken);
//       config.headers.Authorization = `Bearer ${newToken}`;
//     } catch (err) {
//       console.log(err);
      
//       processQueue(err, null);
//       logoutUser();
//       return Promise.reject(err);
//     } finally {
//       isRefreshing = false;
//     }
//   } else if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   return config;
// });

// // ── RESPONSE interceptor: fallback for unexpected 401s ───────────────────
// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     console.log(error);
    
//     const originalRequest = error.config;

//     const isAuthUrl =
//       originalRequest.url?.includes("/login") ||
//       originalRequest.url?.includes("/token/") ||
//       originalRequest.url?.includes("/otp") ||
//       originalRequest.url?.includes("/register");

//     if (
//       error.response?.status === 401 &&
//       !originalRequest._retry &&
//       !isAuthUrl
//     ) {
//       if (isRefreshing) {
//         return new Promise((resolve, reject) => {
//           failedQueue.push({ resolve, reject });
//         }).then((token) => {
//           originalRequest.headers.Authorization = `Bearer ${token}`;
//           return api(originalRequest);
//         });
//       }

//       originalRequest._retry = true;
//       isRefreshing = true;

//       try {
//         const newToken = await refreshAccessToken();
//         console.log(newToken);
        
//         processQueue(null, newToken);
//         originalRequest.headers.Authorization = `Bearer ${newToken}`;
//         return api(originalRequest);
//       } catch (refreshError) {
//         console.log(refreshError);
        
//         processQueue(refreshError, null);
//         logoutUser();
//         return Promise.reject(refreshError);
//       } finally {
//         isRefreshing = false;
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export const axiosBaseQuery =
//   ({ baseUrl } = { baseUrl: '' }) =>
//   async ({ url, method, body, data, params, headers }) => {
//     try {
//       const joinUrls = (base, relative) => {
//         if (!base) return relative;
//         if (!relative) return base;
//         const baseEndsWithSlash = base.endsWith('/');
//         const relativeStartsWithSlash = relative.startsWith('/');
//         if (baseEndsWithSlash && relativeStartsWithSlash) {
//           return base + relative.substring(1);
//         }
//         if (!baseEndsWithSlash && !relativeStartsWithSlash) {
//           return base + '/' + relative;
//         }
//         return base + relative;
//       };

//       const fullUrl = joinUrls(baseUrl, url);

//       const result = await api({
//         url: fullUrl,
//         method,
//         data: body || data,
//         params,
//         headers,
//       });
//       return { data: result.data };
//     } catch (axiosError) {
//       let err = axiosError;
//       return {
//         error: {
//           status: err.response?.status,
//           data: err.response?.data || err.message,
//         },
//       };
//     }
//   };

// export default api;

/**
 * api.js  –  single Axios instance used by EVERY request in the app
 *
 * Strategy
 * ────────
 * 1. REQUEST interceptor  – if the access token is expired (or about to be),
 *    silently refresh BEFORE the request goes out.
 * 2. RESPONSE interceptor – if a 401 slips through anyway (race condition, clock
 *    skew, server-side revocation), refresh and replay once.
 * 3. Only ONE refresh call is ever in-flight at a time; all concurrent requests
 *    queue up and resume with the new token.
 * 4. On refresh failure → clear tokens + redirect to /login (once).
 */

import axios from 'axios'
import { notification } from 'antd'
import {
  getAccessToken,
  getRefreshToken,
  setTokens,
  clearTokens,
  isTokenExpired,
} from '../utilities/tokenUtils'
import { BASE_URL } from '../keys'

// ─── Core instance ────────────────────────────────────────────────────────────

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
})

// ─── Refresh state ────────────────────────────────────────────────────────────

let isRefreshing = false
let queue = []   // { resolve, reject }[]

const flushQueue = (error, token = null) => {
  queue.forEach((p) => (error ? p.reject(error) : p.resolve(token)))
  queue = []
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

// const AUTH_URLS = ['/login', '/token/', '/otp', '/register']
const AUTH_URLS = ['login', 'token/', 'otp', 'register']
const isAuthUrl = (url = '') => AUTH_URLS.some((u) => url.includes(u))
console.log(AUTH_URLS);
console.log(isAuthUrl);

let logoutScheduled = false
function logout() {
  if (logoutScheduled) return
  logoutScheduled = true
  clearTokens()
  notification.error({
    message: 'Session expired',
    description: 'Please log in again.',
  })
  setTimeout(() => {
    logoutScheduled = false        // reset so future logins work
    window.location.href = '/login'
  }, 1500)
}

/**
 * Calls the refresh endpoint and stores both new tokens.
 * Returns the new access token.
 * Throws on failure.
 */
async function doRefresh() {
  const refresh = getRefreshToken()
  if (!refresh) throw new Error('No refresh token stored')

  // Use a plain axios call — NOT the `api` instance — to avoid interceptor loops
  const { data } = await axios.post(`${BASE_URL}api/token/refresh`, { refresh })

  const newAccess  = data.access
  // Some backends rotate the refresh token; support both field names
  const newRefresh = data.refresh ?? data.refresh_token ?? null

  // Always persist both tokens
  setTokens(newAccess, newRefresh ?? refresh)   // keep old refresh if not rotated

  return newAccess
}

// ─── REQUEST interceptor ─────────────────────────────────────────────────────

api.interceptors.request.use(async (config) => {
  // Don't touch auth endpoints
  if (isAuthUrl(config.url)) return config

  // Always use fresh token from storage, not a stale closure
  const accessToken = getAccessToken()

  if (!isTokenExpired(accessToken)) {
    // Token is still valid — attach and go
    config.headers.Authorization = `Bearer ${accessToken}`
    return config
  }

  // Token expired (or missing) — need to refresh before sending
  if (isRefreshing) {
    // Another request is already refreshing — wait for it
    return new Promise((resolve, reject) => {
      queue.push({
        resolve: (token) => {
          config.headers.Authorization = `Bearer ${token}`
          resolve(config)
        },
        reject,
      })
    })
  }

  isRefreshing = true
  try {
    const newToken = await doRefresh()
    flushQueue(null, newToken)
    config.headers.Authorization = `Bearer ${newToken}`
    return config
  } catch (err) {
    flushQueue(err)
    logout()
    return Promise.reject(err)
  } finally {
    isRefreshing = false
  }
})

// ─── RESPONSE interceptor ────────────────────────────────────────────────────

api.interceptors.response.use(
  (response) => response,

  async (error) => {
    const original = error.config

    // Only act on 401s that aren't from auth endpoints and haven't been retried
    if (
      error.response?.status !== 401 ||
      original._retry ||
      isAuthUrl(original.url)
    ) {
      return Promise.reject(error)
    }

    if (isRefreshing) {
      // Queue while refresh is in-flight
      return new Promise((resolve, reject) => {
        queue.push({
          resolve: (token) => {
            original.headers.Authorization = `Bearer ${token}`
            resolve(api(original))
          },
          reject,
        })
      })
    }

    original._retry  = true
    isRefreshing     = true

    try {
      const newToken = await doRefresh()
      flushQueue(null, newToken)
      original.headers.Authorization = `Bearer ${newToken}`
      return api(original)
    } catch (refreshError) {
      flushQueue(refreshError)
      logout()
      return Promise.reject(refreshError)
    } finally {
      isRefreshing = false
    }
  }
)

// ─── RTK Query base-query adapter ────────────────────────────────────────────

export const axiosBaseQuery =
  ({ baseUrl = '' } = {}) =>
  async ({ url, method = 'GET', body, data, params, headers = {} }) => {
    const joinUrls = (base, rel) => {
      if (!base) return rel
      if (!rel) return base
      const slash = base.endsWith('/') || rel.startsWith('/')
      return slash
        ? `${base.replace(/\/$/, '')}/${rel.replace(/^\//, '')}`
        : `${base}/${rel}`
    }

    try {
      const result = await api({
        url: joinUrls(baseUrl, url),
        method,
        data: body ?? data,
        params,
        headers,
      })
      return { data: result.data }
    } catch (err) {
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data ?? err.message,
        },
      }
    }
  }

export default api